// extracted by mini-css-extract-plugin
export default {"wrapperTag":"styles_wrapperTag__D1ERk","tagCloseIcon":"styles_tagCloseIcon__jPkYp","primary":"styles_primary__JrIQx"};